import { z } from "zod";

export const loginSchema = z.object({
  email: z
    .string({ required_error: "El correo electrónico es obligatorio" })
    .email("Ingresa un correo electrónico válido"),

  password: z
    .string({ required_error: "La contraseña es obligatoria" })
    .min(1, "La contraseña es obligatoria")
    .optional(),

  rememberMe: z.boolean(),
});

export type LoginSchema = z.infer<typeof loginSchema>;
